// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"abbb8082","604":"86969ee5","766":"98eeb817","808":"98eeb817","864":"2e923824"}[chunkId] + ".chunk.css";
};